import { render, staticRenderFns } from "./SimplePreloader.vue?vue&type=template&id=34931095&scoped=true&"
import script from "./SimplePreloader.vue?vue&type=script&lang=ts&"
export * from "./SimplePreloader.vue?vue&type=script&lang=ts&"
import style0 from "./SimplePreloader.vue?vue&type=style&index=0&id=34931095&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34931095",
  null
  
)

export default component.exports